module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/ui/analytics-2-ae63f6a8d877b88cc875ca9797a6590d.png";